/**
 * Coup de pouce — Attendu 1055 « prendre une fraction simple d'un nombre :
 * le 1/3 de 18 ; le 1/4 de 12 ». UNE page STATIQUE partagée par les deux
 * generator_keys (même geste). Phrases validées en texte nu par le prof le
 * 2026-09-09 (procédure « les phrases avant le dessin »), codées mot pour
 * mot.
 *
 * L'image que l'élève a déjà : le schéma en barres de 1046 et 1049, et
 * l'image exacte de la ressource Eduscol « Exemples de mise en œuvre pour
 * l'enseignement des fractions du CE1 au CM2 » (2025, page 7) : une barre
 * partagée en trois avec la première part marquée. Quatre éléments, deux
 * couleurs :
 *   1. une barre entière, étiquetée 18 ;
 *   2. dessous, la même longueur partagée en 3 parts égales par des traits
 *      bleus, chaque part étiquetée 6, la première coloriée en orange ;
 *   3. en gros : le 1/3 de 18 = 6, le 3 en bleu, le 6 en orange (sans la
 *      flèche « c'est là », retirée partout le 2026-09-09) ;
 *   4. UNE ligne du geste, le fait de table (prof, 2026-09-09 : « l'élève
 *      doit connaître ses tables ici ») : « 18, c'est 3 × 6 : une part,
 *      c'est 6. » Les trois lignes d'avant (partage, 18 ÷ 3, vérification)
 *      sont retirées au standard de 1054 : dessin, calcul, une ligne.
 * Coupé à l'épreuve de Musk : « le 1/3 de 18 = ? » en haut (même ligne que
 * le résultat, le titre dit déjà ce qu'on fait). Mots : parts égales,
 * partager, une part ; jamais « tiers », « dénominateur », « diviser ».
 *
 * SACRIFIÉ : le 1/3 de 18 ne sort d'aucune carte (gen_1055, auto-testé par
 * cdp1055.self.test.js). Largeur bornée à 340 px, tailles de 1048.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS_CLAIR = '#E2E8F0';

/** Les barres : 300 px de long, 30 px de haut. */
const XB = 50;
const LB = 300;
const HB = 30;
const Y1 = 34;
const Y2 = 92;
const PARTS = 3;

/** La barre partagée en 3 parts égales, traits bleus, la première en orange, chaque part étiquetée 6. */
const BARRE_PARTAGEE = Array.from({ length: PARTS }, (_, i) => {
    const x = XB + (i * LB) / PARTS;
    const w = LB / PARTS;
    const premiere = i === 0;
    return `<rect x="${x}" y="${Y2}" width="${w}" height="${HB}" fill="${premiere ? ORANGE_CLAIR : '#FFFFFF'}" stroke="${BLEU}" stroke-width="2"/>
  <text x="${x + w / 2}" y="${Y2 + 20}" font-size="14" font-weight="bold" text-anchor="middle" fill="${premiere ? ORANGE : ENCRE}">6</text>`;
}).join('\n  ');

const SVG_PARTAGE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 226" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="Une barre entière étiquetée 18. Dessous, la même longueur partagée en 3 parts égales, chaque part étiquetée 6, la première en orange. Le 1 sur 3 de 18 égale 6. 18, c'est 3 fois 6 : une part, c'est 6.">
  <!-- 1. la barre entière : 18 -->
  <rect x="${XB}" y="${Y1}" width="${LB}" height="${HB}" fill="${GRIS_CLAIR}" stroke="${ENCRE}" stroke-width="1.6"/>
  <text x="${XB + LB / 2}" y="${Y1 + 20}" font-size="14" font-weight="bold" text-anchor="middle" fill="${ENCRE}">18</text>

  <!-- 2. la même longueur partagée en 3 parts égales -->
  ${BARRE_PARTAGEE}

  <!-- 3. le résultat -->
  <text x="100" y="172" font-size="15" font-weight="bold" text-anchor="middle" fill="${ENCRE}">le</text>
  <text x="124" y="163" font-size="15" font-weight="bold" text-anchor="middle" fill="${ENCRE}">1</text>
  <line x1="113" y1="167" x2="135" y2="167" stroke="${ENCRE}" stroke-width="1.8"/>
  <text x="124" y="183" font-size="15" font-weight="bold" text-anchor="middle" fill="${BLEU}">3</text>
  <text x="172" y="172" font-size="15" font-weight="bold" text-anchor="middle" fill="${ENCRE}">de 18 =</text>
  <text x="212" y="173" font-size="19" font-weight="bold" text-anchor="middle" fill="${ORANGE}">6</text>

  <!-- 4. le geste : le fait de table -->
  <text x="200" y="214" font-size="15" text-anchor="middle" fill="${ENCRE}">18, c'est <tspan font-weight="bold" fill="${BLEU}">3</tspan> × <tspan font-weight="bold" fill="${ORANGE}">6</tspan> : une part, c'est <tspan font-weight="bold" fill="${ORANGE}">6</tspan>.</text>
</svg>`.trim();

const AIDE = {
    pages: [
        { titre: 'Je partage 18 en 3 parts égales', svg: SVG_PARTAGE },
    ],
};

const CP_1055 = {
    flash_texte_trou_saisie: AIDE,
    verif_qcm_unique: AIDE,
    verif_tableau_vf: AIDE,
};

export default CP_1055;
